/* Perro Collection — Size & Fit Finder (ES build) */

const PERRO_SIZE_DATA = {
  collar: {
    label: 'Collar',
    cta: { href: '/es/collections/collars', label: 'Descubre los collares' },
    measurements: [
      { key: 'neck', label: 'Contorno del cuello', tip: 'Mide donde el collar se apoya de forma natural, ajustado y sin holgura.' }
    ],
    sizes: [
      { size: '25', neck: [15, 17], width: '1,5 cm', breeds: 'Chihuahua, cachorros recién nacidos' },
      { size: '30', neck: [18, 23], width: '1,5 cm', breeds: 'Chihuahua, Pomerania, Caniche Toy' },
      { size: '35', neck: [23, 29], width: '1,5-2 cm', breeds: 'Pomerania, Teckel, Bichón Maltés, Caniche' },
      { size: '40', neck: [30, 33], width: '2 cm', breeds: 'Bulldog Francés, Jack Russell, Carlino, Boston Terrier' },
      { size: '45', neck: [33, 38], width: '2 cm', breeds: 'Beagle, Cocker Spaniel, Carlino' },
      { size: '55', neck: [41, 50], width: '2,5 cm', breeds: 'Bulldog Francés, Cocker Spaniel' }
    ]
  },

  'harness-stepin': {
    label: 'Arnés Step-in',
    cta: { href: '/es/collections/step-in-harness', label: 'Descubre los arneses Step-in' },
    measurements: [
      { key: 'chest', label: 'Contorno del pecho', tip: 'Mide alrededor del pecho, justo detrás de las axilas.' }
    ],
    sizes: [
      { size: 'XXS', chest: [25, 27], width: '1,5 cm', breeds: 'Cachorro de Chihuahua, razas Toy' },
      { size: 'XS',  chest: [29, 34], width: '1,5 cm', breeds: 'Chihuahua, Yorkshire Terrier, Caniche' },
      { size: 'S',   chest: [35, 39], width: '1,5-2 cm', breeds: 'Pomerania, Teckel, Caniche' },
      { size: 'M',   chest: [40, 43], width: '2 cm', breeds: 'Bulldog Francés, Shiba Inu, Caniche, Boston Terrier' },
      { size: 'L',   chest: [43, 49], width: '2 cm', breeds: 'Beagle, Cocker Spaniel, Carlino' },
      { size: 'L/XL',chest: [49, 52], width: '2 cm', breeds: 'Border Collie, Cocker Spaniel' },
      { size: 'XL',  chest: [53, 62], width: '2 cm', breeds: 'Bulldog Francés, Dálmata, Boston Terrier' },
      { size: 'XXL', chest: [63, 69], width: '2 cm', breeds: 'Bulldog Francés, Goldendoodle, Carlino' }
    ]
  },

  'harness-h': {
    primary: 'chest',
    label: 'Arnés en H',
    cta: { href: '/es/collections/h-harness', label: 'Descubre los arneses en H' },
    measurements: [
      { key: 'neck',  label: 'Contorno del cuello', tip: 'Mide todo el contorno del cuello.' },
      { key: 'chest', label: 'Contorno del pecho', tip: 'Mide alrededor del pecho, justo detrás de las axilas.' }
    ],
    sizes: [
      { size: 'XXS', neck: [19, 23], chest: [27, 32], width: '1,5 cm', breeds: 'Cachorro, Toy' },
      { size: 'XS',  neck: [24, 30], chest: [37, 43], width: '1,5 cm', breeds: 'Chihuahua, Bichón Maltés, Caniche' },
      { size: 'S',   neck: [27, 33], chest: [42, 48], width: '1,5-2 cm', breeds: 'Schnauzer, Pomerania, Caniche' },
      { size: 'M',   neck: [30, 36], chest: [45, 51], width: '2 cm', breeds: 'Bulldog Francés, Caniche, Boston Terrier' },
      { size: 'L',   neck: [33, 39], chest: [50, 56], width: '2 cm', breeds: 'Border Collie, Vizsla, Cocker Spaniel' },
      { size: 'XL',  neck: [36, 42], chest: [55, 61], width: '2 cm', breeds: 'Bulldog Francés, Braco de Weimar, Carlino' },
      { size: 'XXL', neck: [40, 45], chest: [58, 65], width: '2 cm', breeds: 'Pastor Alemán, Bulldog Francés' }
    ]
  },

  leash: {
    label: 'Correa',
    cta: { href: '/es/collections/leash', label: 'Descubre las correas' },
    measurements: [],
    sizes: [
      { size: 'Short S', length: '130 cm', width: '1,5 cm', breeds: 'Combina con collar / arnés de 1,5 cm' },
      { size: 'Short M', length: '130 cm', width: '2 cm',   breeds: 'Combina con collar / arnés de 2 cm' },
      { size: 'Long S',  length: '245 cm', width: '1,5 cm', breeds: 'Combina con collar / arnés de 1,5 cm' },
      { size: 'Long M',  length: '235 cm', width: '2 cm',   breeds: 'Combina con collar / arnés de 2 cm' }
    ],
    leashOnly: true
  },

  sweater: {
    primary: 'chest',
    label: 'Jersey',
    cta: { href: '/es/collections/perro-knitwear', label: 'Descubre los jerséis' },
    measurements: [
      { key: 'chest', label: 'Contorno del pecho', tip: 'Mide justo detrás de las patas delanteras, en la parte más ancha del pecho.' },
      { key: 'neck',  label: 'Contorno del cuello', tip: 'Mide donde quedará la abertura del cuello del jersey.' }
    ],
    sizes: [
      { size: 'XS', chest: [25, 28], neck: [15, 18], breeds: 'Chihuahua, Caniche Toy' },
      { size: 'S',  chest: [29, 34], neck: [18, 22], breeds: 'Pomerania, Teckel' },
      { size: 'M',  chest: [35, 38], neck: [22, 25], breeds: 'Bulldog Francés, Boston Terrier' },
      { size: 'L',  chest: [39, 45], neck: [25, 27], breeds: 'Beagle, Cocker Spaniel' }
    ]
  }
};

const state = { product: 'collar', unit: 'cm', mode: 'measure', values: {} };

const urlProduct = new URLSearchParams(window.location.search).get('product');
const bodyProduct = document.body.dataset.product;
if (urlProduct && PERRO_SIZE_DATA[urlProduct]) state.product = urlProduct;
else if (bodyProduct && PERRO_SIZE_DATA[bodyProduct]) state.product = bodyProduct;

function parseLocaleNumber(raw) { return parseFloat(String(raw).replace(',', '.')); }
function commaNum(n) { return String(n).replace('.', ','); }

function renderProductPills() {
  const wrap = document.getElementById('productPills');
  wrap.innerHTML = '';
  Object.keys(PERRO_SIZE_DATA).forEach(key => {
    const btn = document.createElement('button');
    btn.className = 'pill';
    btn.setAttribute('role', 'tab');
    btn.setAttribute('aria-selected', key === state.product);
    btn.dataset.product = key;
    btn.textContent = PERRO_SIZE_DATA[key].label;
    btn.addEventListener('click', () => {
      state.product = key;
      state.values = {};
      renderProductPills();
      renderAll();
    });
    wrap.appendChild(btn);
  });
}

function renderMeasure() {
  const data = PERRO_SIZE_DATA[state.product];
  const fields = document.getElementById('measureFields');
  const diagramLabel = document.getElementById('diagramLabel');
  const diagramTip = document.getElementById('diagramTip');
  const resultBox = document.getElementById('resultBox');
  const unitLabel = state.unit === 'in' ? 'in' : 'cm';

  if (data.leashOnly) {
    fields.innerHTML = `
      <div class="diagram-card" style="background:#fdfaf5; border:1px solid var(--c-line); margin-bottom:0;">
        <div class="diagram-card__label">Combina la correa con el collar o el arnés</div>
        <p class="diagram-card__tip">Si ya tienes un collar o un arnés Perro, elige el ancho de la correa según el ancho de la piel de tu collar o arnés (1,5 cm o 2 cm).</p>
        <p class="diagram-card__tip" style="margin-top:12px;">Elige entre correa corta (130 cm) o correa larga (245 o 235 cm) según tu preferencia. Las correas largas son ajustables en 3 longitudes y se pueden llevar cruzadas al hombro.</p>
        <a href="${data.cta.href}" style="display:inline-block;margin-top:16px;padding:14px 24px;background:#1a1a1a;color:#fff;text-decoration:none;border-radius:2px;font-size:13px;letter-spacing:.08em;text-transform:uppercase;">${data.cta.label}</a>
      </div>
    `;
    resultBox.style.display = 'none';
    document.getElementById('diagramLegend').style.display = 'none';
    diagramLabel.textContent = 'Encuentra tu combinación';
    diagramTip.textContent = 'Combina el ancho de la correa con el ancho de la piel de tu collar o arnés.';
    return;
  }

  resultBox.style.display = 'block';
  fields.innerHTML = '';

  const legend = document.getElementById('diagramLegend');
  const legendNeck = legend.querySelector('[data-point="A"]');
  const legendChest = legend.querySelector('[data-point="B"]');
  legendNeck.style.display = 'none';
  legendChest.style.display = 'none';

  data.measurements.forEach(m => {
    if (m.key === 'neck') legendNeck.style.display = '';
    if (m.key === 'chest') legendChest.style.display = '';
  });

  legend.style.display = data.measurements.length > 0 ? 'flex' : 'none';

  if (data.measurements[0]) {
    diagramLabel.textContent = 'Cómo medir';
    const allTips = data.measurements
      .map((m, idx) => {
        let t = m.tip.replace(/\.\s*$/, '');
        if (idx > 0) t = t.replace(/^Mide\s+/i, '');
        return t;
      })
      .join(' & ') + '.';
    diagramTip.textContent = allTips;
  }

  data.measurements.forEach((m) => {
    const pointLetter = m.key === 'neck' ? 'A' : m.key === 'chest' ? 'B' : '';
    const wrap = document.createElement('div');
    wrap.className = 'field';
    wrap.innerHTML = `
      <label class="field__label" for="input-${m.key}">
        <span class="field__label-text">
          ${pointLetter ? `<span class="field__point">${pointLetter}</span>` : ''}
          ${m.label}
        </span>
        <span class="field__help">${m.tip.split('.')[0]}</span>
      </label>
      <div class="field__input-wrap">
        <input type="text" inputmode="decimal" autocomplete="off"
               class="field__input" id="input-${m.key}"
               data-key="${m.key}"
               placeholder="${getPlaceholder(m.key)}">
        <span class="field__unit">${unitLabel}</span>
      </div>
    `;
    fields.appendChild(wrap);

    const input = wrap.querySelector('input');
    if (state.values[m.key] != null) {
      input.value = state.unit === 'cm'
        ? commaNum(state.values[m.key])
        : commaNum((state.values[m.key] / 2.54).toFixed(1));
    }
    input.addEventListener('input', e => {
      const val = parseLocaleNumber(e.target.value);
      if (isNaN(val) || val <= 0) { delete state.values[m.key]; }
      else { state.values[m.key] = state.unit === 'cm' ? val : val * 2.54; }
      calculateAndShowResult();
    });
    input.addEventListener('focus', () => updateDiagramFor(m));
  });

  calculateAndShowResult();
}

function getPlaceholder(key) {
  const examples = {
    neck:  state.unit === 'cm' ? '32' : '12,6',
    chest: state.unit === 'cm' ? '45' : '17,7'
  };
  return examples[key] || '';
}

function updateDiagramFor(measurement) {
  document.getElementById('diagramTip').textContent = measurement.tip;
}

function calculateAndShowResult() {
  const data = PERRO_SIZE_DATA[state.product];
  const resultBox = document.getElementById('resultBox');
  const required = data.measurements.map(m => m.key);
  const hasAll = required.every(k => state.values[k] != null && state.values[k] > 0);

  if (!hasAll) {
    const missing = required.filter(k => !state.values[k]);
    resultBox.className = 'result result--empty';
    resultBox.innerHTML = `
      <span class="result__icon">·</span>
      <div>${missing.length === required.length
        ? 'Tu talla recomendada aparecerá aquí'
        : 'Añade ' + missing.length + ' medida' + (missing.length > 1 ? 's' : '') + ' más'}</div>
    `;
    return;
  }

  // Randen-playbook (audit aug 2026): overlap -> grootste maat, micro-gat
  // (<= 1 cm tussen ranges) -> grootste buurmaat, echt gat of buiten bereik
  // -> contact. Bij 2 metingen beslist de borst, de hals is controle.
  function locateIn(key, v) {
    const ranged = [];
    data.sizes.forEach((s, i) => { if (s[key]) ranged.push({ i, r: s[key] }); });
    let hit = -1, hitCount = 0;
    ranged.forEach(x => { if (v >= x.r[0] && v <= x.r[1]) { hit = x.i; hitCount++; } });
    if (hit > -1) return { t: 'hit', i: hit, multi: hitCount > 1 };
    if (v < ranged[0].r[0] || v > ranged[ranged.length - 1].r[1]) return { t: 'none' };
    for (let j = 0; j < ranged.length - 1; j++) {
      const cur = ranged[j], nxt = ranged[j + 1];
      if (v > cur.r[1] && v < nxt.r[0]) {
        return (nxt.r[0] - cur.r[1] <= 1) ? { t: 'snap', i: nxt.i } : { t: 'none' };
      }
    }
    return { t: 'none' };
  }

  const primary = data.primary || required[0];
  const pLoc = locateIn(primary, state.values[primary]);
  let result = null, confidence;

  if (pLoc.t !== 'none') {
    let idx = pLoc.i;
    confidence = pLoc.t === 'snap' ? 'split' : (pLoc.multi ? 'good' : 'high');
    for (const sec of required) {
      if (sec === primary) continue;
      const sLoc = locateIn(sec, state.values[sec]);
      if (sLoc.t === 'none') { confidence = 'none'; break; }
      const sr = data.sizes[idx][sec];
      const inRange = sr && state.values[sec] >= sr[0] && state.values[sec] <= sr[1];
      if (!inRange) {
        if (sLoc.i === idx + 1) { idx = sLoc.i; confidence = 'split'; }
        else if (sLoc.i > idx + 1) { confidence = 'none'; break; }
        else if (confidence === 'high') { confidence = 'good'; }
      }
    }
    if (confidence !== 'none') result = data.sizes[idx];
  }

  if (!result) {
    // Toon de dichtstbijzijnde maat als context; advies = contact.
    const scored = data.sizes.map(s => {
      let totalDist = 0;
      required.forEach(key => {
        const range = s[key];
        const val = state.values[key];
        if (!range) return;
        if (val < range[0]) totalDist += range[0] - val;
        else if (val > range[1]) totalDist += val - range[1];
      });
      return { size: s, dist: totalDist };
    }).sort((a, b) => a.dist - b.dist);
    result = scored[0].size;
    confidence = 'none';
  }

  renderResult(result, confidence);
}

function renderResult(size, confidence) {
  const resultBox = document.getElementById('resultBox');
  const data = PERRO_SIZE_DATA[state.product];

  let confLabel = '', confClass = '';
  if (confidence === 'high') { confLabel = 'Ajuste perfecto'; }
  else if (confidence === 'good') { confLabel = 'Muy buen ajuste'; }
  else if (confidence === 'split') { confLabel = 'Entre dos tallas, te recomendamos la mayor'; }
  else if (confidence === 'low') { confLabel = 'Te recomendamos una talla más'; confClass = 'result__confidence--warn'; }
  else { confLabel = '<a href="mailto:info@perrocollection.com" style="color:inherit;">Fuera de nuestro rango estándar, contáctanos</a>'; confClass = 'result__confidence--warn'; }

  const ranges = data.measurements.map(m => {
    const r = size[m.key];
    if (!r) return '';
    return `${m.label}: ${r[0]}-${r[1]} cm`;
  }).filter(Boolean).join(' · ');

  const cta = (confidence !== 'none' && data.cta)
    ? `<a class="result__cta" href="${data.cta.href}" style="display:inline-block;margin-top:18px;padding:14px 24px;background:#1a1a1a;color:#fff;text-decoration:none;border-radius:2px;font-size:13px;letter-spacing:.08em;text-transform:uppercase;">${data.cta.label}</a>`
    : '';

  resultBox.className = 'result';
  resultBox.innerHTML = `
    <div class="result__eyebrow">Tu talla</div>
    <div class="result__size">${size.size}</div>
    <div class="result__label">${data.label}</div>
    ${ranges ? `<div class="result__range">${ranges}</div><br>` : ''}
    <div class="result__confidence ${confClass}">${confLabel}</div>
    ${size.breeds ? `<p class="result__notes">Ideal para ${size.breeds}.</p>` : ''}
    ${cta}
  `;
}

function renderTable() {
  const data = PERRO_SIZE_DATA[state.product];
  const headRow = document.getElementById('tableHeadRow');
  const body = document.getElementById('tableBody');
  const header = document.getElementById('tableHeader');
  const title = document.getElementById('tableTitle');

  header.textContent = data.label;
  // Width-kolom alleen tonen als er echt width-data is (bv. sweater heeft die niet).
  const hasWidth = data.sizes.some(function(s){ return s.width != null && s.width !== ''; });
  title.textContent = 'Tabla de tallas: ' + data.label;

  let cols = ['Talla'];
  if (data.leashOnly) {
    cols = ['Tipo', 'Longitud', 'Ancho', 'Combina con'];
  } else {
    data.measurements.forEach(m => cols.push(m.label));
    if (hasWidth) cols.push('Ancho');
    cols.push('Razas típicas');
  }
  headRow.innerHTML = cols.map(c => `<th>${c}</th>`).join('');

  body.innerHTML = data.sizes.map(s => {
    if (data.leashOnly) {
      return `
        <tr>
          <td class="col-size col-size--type">${s.size}</td>
          <td class="col-measure">${s.length}</td>
          <td class="col-measure">${s.width}</td>
          <td class="col-breeds">${s.breeds}</td>
        </tr>
      `;
    }
    const measureCells = data.measurements.map(m => {
      const r = s[m.key];
      if (!r) return '<td><span style="color:var(--c-mute)">n/d</span></td>';
      const inMin = commaNum((r[0] / 2.54).toFixed(1));
      const inMax = commaNum((r[1] / 2.54).toFixed(1));
      const displayRange = r[0] === r[1] ? `${r[0]} cm` : `${r[0]}-${r[1]} cm`;
      const displayIn = r[0] === r[1] ? `${inMin}"` : `${inMin}-${inMax}"`;
      return `<td class="col-measure">${displayRange}<small>${displayIn}</small></td>`;
    }).join('');
    return `
      <tr>
        <td class="col-size">${s.size}</td>
        ${measureCells}
        ${hasWidth ? `<td class="col-measure">${s.width}</td>` : ''}
        <td class="col-breeds">${s.breeds}</td>
      </tr>
    `;
  }).join('');
}

function switchMode(mode) {
  state.mode = mode;
  document.querySelectorAll('.mode-btn').forEach(b => b.setAttribute('aria-selected', b.dataset.mode === mode));
  document.querySelectorAll('.panel').forEach(p => { p.hidden = p.id !== 'panel-' + mode; });
  if (mode === 'table') renderTable();
  if (mode === 'measure') renderMeasure();
}

function switchUnit(unit) {
  state.unit = unit;
  document.querySelectorAll('.unit-btn').forEach(b => b.setAttribute('aria-checked', b.dataset.unit === unit));
  renderMeasure();
}

document.querySelectorAll('.mode-btn').forEach(btn => btn.addEventListener('click', () => switchMode(btn.dataset.mode)));
document.querySelectorAll('.unit-btn').forEach(btn => btn.addEventListener('click', () => switchUnit(btn.dataset.unit)));

function renderAll() { renderMeasure(); renderTable(); }

window.PerroSizeFinder = {
  init: function(opts) {
    if (opts && opts.product && PERRO_SIZE_DATA[opts.product]) state.product = opts.product;
    if (opts && opts.mode) switchMode(opts.mode);
    renderProductPills();
    renderAll();
  },
  setProduct: function(key) {
    if (PERRO_SIZE_DATA[key]) { state.product = key; state.values = {}; renderProductPills(); renderAll(); }
  }
};

renderProductPills();
renderAll();

/* Reveal-gate: toon de finder pas als de content is opgebouwd (voorkomt flits/CLS). */
document.querySelector('.sf-gate')?.classList.add('sf-ready');
